import produce from 'immer';
import { uniqueId } from 'lodash';
import { NOTIFICATION_TYPE } from './type';

const initialState = {
  notifications: [],
};
export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_TYPE.PUSH_NOTIFICATION:
      return produce(state, (draft) => {
        const {
          description,
          title,
          notificationId,
          disallowClose = false,
          isLoading = true,
        } = action;
        draft.notifications.push({
          description,
          title,
          disallowClose,
          isLoading,
          id: notificationId || uniqueId(),
          isPinned: false,
          createdAt: Date.now(),
        });
      });
    case NOTIFICATION_TYPE.REMOVE_NOTIFICATION:
      return produce(state, (draft) => {
        const notificationNecessary = state.notifications.filter(
          (notification) => notification?.id !== action?.notificationId
        );
        draft.notifications = notificationNecessary;
      });

    case NOTIFICATION_TYPE.PIN_NOTIFICATION:
      return produce(state, (draft) => {
        const notification = draft.notifications.find(
          (n) => n.id === action.notificationId
        );
        if (notification) {
          notification.isPinned = true;
        }
      });

    default:
      return state;
  }
};
